<template>
  <div class="animated fadeIn list-of-coa">
    <b-row class="justify-content-center">
      <b-col lg="11" xl="10">
        <b-card>
          <div slot="header">Consolidation Chart of Account
            <div class="card-header-actions">
              <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
              <b-button variant="btn btn-primary mr-1" @click="print">Print</b-button>
              <b-button variant="btn btn-primary mr-1" @click="exportXls">Export</b-button>
              <b-button variant="btn btn-primary" @click="close">Close</b-button>
            </div>
          </div>
          <b-row >
            <b-col lg="9">
                <b-input-group >
                  <b-input-group-prepend><span class="pt-2 pr-2">Account Code</span></b-input-group-prepend>
                  <b-form-input v-model="tblData.kodeacc"></b-form-input>
                  <b-input-group-prepend><span class="input-group-text">Name</span></b-input-group-prepend>
                  <b-form-input v-model="tblData.namaacc" style="width:35% !important;"></b-form-input>
                  <b-input-group-append>
                      <b-button class="btn btn-success ml-3" @click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                  </b-input-group-append>
                  <b-input-group-append>
                    <b-button class="btn btn-secondary ml-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
                  </b-input-group-append>
                </b-input-group>
            </b-col>
          </b-row>
          <b-table
            class="mb-0"
            ref="table"
            outlined
            responsive striped hover
            style="font-size:smaller;" 
            :items="data"
            :fields="tblData.fields"
            :current-page="tblData.page"
            :per-page="tblData.limit"
            :sort-by.sync="tblData.sortBy"
            :sort-desc.sync="tblData.sortDesc"
            @filtered="onFiltered"
          >
              <template v-slot:cell(namaacc)="data">
                <!-- <span v-if="(data.item.judul=='Y')" v-html="data.item.namaacc" style="font-weight:bold;" :style="`margin-left:${data.item.level_*5}px`"></span>
                <span v-else v-html="data.item.namaacc" :style="`margin-left:${data.item.level_*5}px`"></span> -->
                <span v-if="(data.item.judul=='Y')"  style="font-weight:bold;" :style="`margin-left:${data.item.level_*5}px`">{{data.item.namaacc}}</span>
                <span v-else  :style="`margin-left:${data.item.level_*5}px`">{{data.item.namaacc}}</span>
              </template>

            <template v-slot:cell(awal)="data">
              <span v-if="(data.item.judul=='Y')" style="font-weight:bold;">{{data.item.awal|numFormat}}</span>
              <span v-else>{{data.item.awal|numFormat}}</span>
            </template>


            <template v-slot:cell(action)="data">
              <div class="text-center">
              <a href="javascript:void(0)" @click="edit(data.item)">
                <i class="fa fa-pencil"></i>
              </a>
              |
              <a href="javascript:void(0)" class="text-danger" @click="deleteConfirm(data.item)">
                <i class="fa fa-trash"></i>
              </a>
              </div>
            </template>
          </b-table>
          <b-row class="mt-2">
            <b-col cols="4">
              <div>
                Showing {{(tblData.page - 1) * tblData.limit + 1}}
                to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
                of {{tblData.total}} entries
              </div>
            </b-col>
            <b-col cols="4" >
              <b-input-group style="width: 200px;">
                  <b-input-group-prepend class="mb-0"><span class="p-2">Limit per page</span></b-input-group-prepend>
                    <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  style="width:80px;"/>
              </b-input-group>
            </b-col>        
            <b-col cols="4">            
              <b-pagination
                align="right"
                :total-rows="tblData.total"
                :per-page="tblData.limit"
                v-model="tblData.page"
              ></b-pagination>
            </b-col>
          </b-row>
          <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
            <p class="mb-1">1 record is about to be permanently deleted</p>
            <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
          </b-modal>
        <b-modal v-model="showForm" header-bg-variant="primary"  :title="formTitle" :centered="true" @ok="handleOk">
          <b-form @submit.stop.prevent="save">
              <b-form-group label-cols=3 label="Account Code" >
                <b-form-input v-model="model.kodeacc" id="inputKodeacc" aria-describedby="inputKodeaccFeedback" :state="$v.model.kodeacc.required"></b-form-input>
                <b-form-invalid-feedback id="inputKodeaccFeedback">
                  Field is required 
                </b-form-invalid-feedback>            
              </b-form-group>
              
              <b-form-group label-cols=3 label="Account Name">
                <b-form-input v-model="model.namaacc" id="inputNamaacc" aria-describedby="inputNamaaccFeedback" :state="$v.model.namaacc.required"></b-form-input>
                <b-form-invalid-feedback id="inputNamaaccFeedback">
                  Field is required 
                </b-form-invalid-feedback>            
              </b-form-group>
              <b-form-group label-cols=3 label="Account Type">
                <b-form-select v-model="model.typeacc" :plain="true" :options="accountType" :state="$v.model.typeacc.required"></b-form-select>
              </b-form-group>
              <b-form-group label-cols=3 label=" Account Flag">
                <b-form-select v-model="model.tanda_nrc" :plain="true" :options="accountFlag"></b-form-select>
              </b-form-group>
              <b-form-group label-cols=3 label="Begining Balance">
                <v-number class="form-control text-right" separator="," v-model="model.awal"></v-number>
              </b-form-group>
          </b-form>
        </b-modal>
        </b-card>
      </b-col>
    </b-row>

    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Print Chart Of Account">
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
  </div>
</template>

<style lang="scss">
  .list-of-coa {
    table {
      td:nth-child(1) {
        width: auto;
      }
      td:nth-child(2) {
        width: 120px;
      }
    }
  iframe {
    border: 1px solid #ccc;
    width: 100%;
    height: 11in;
  }
}
</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
// import moment from "moment";
import coa from "../../apis/consolidacoa";
import vNumber from "vue-numeric";
import { validationMixin } from "vuelidate";
import { required, maxLength,numeric } from "vuelidate/lib/validators";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    model: {
      kodeacc: {
        required,
         maxLength: maxLength(50)
      },
      namaacc: {
        required,
         maxLength: maxLength(100)
      },
      typeacc: { required },
    }
  },  
  components: { Loading,vNumber },
  data() {
    return {
      accountType : [{ value: 'DEBIT', text: 'DEBIT' }, { value: 'CREDIT', text: 'CREDIT' }],
      accountFlag : [
                { value: '0', text: 'Normal Account' },
                { value: '1', text: 'First Level of ASSET' },
                { value: '2', text: 'First Level of LIABILITIES' },
                { value: '3', text: 'First Level of EQUITY' },
                { value: '8', text: 'Retain Earning' }, 
                { value: '9', text: 'Profit/(Loss) Current Year' }
            ],
      formTitle: 'Add - Chart of Account',
      showForm:false,
      showReport:false,
      showDelConfirm: false,
      isLoading : false,
      horizontal: true,
      model:{},
      tblData: {
        items: [],
        fields: [
          {
            key: "kodeacc",
            label: "Account Code",
            thStyle: "width:80px",
            sortable: true
          },
          {
            key: "namaacc",
            label: "Account Name",
          },
          {
            key: "typeacc",
            thStyle: "width:80px",
            label: "Type"
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:50px",
            thClass: "text-center",
          },

        ],
        page: 1,
        limit: 15,
        total: 0,
        
        sortBy: null,
        sortDesc: false,
        holdingcode:  this.$store.state.user.compcode,
      },
      user: this.$store.state.user,
      reportUrl: null
    };
  },
  // created: async function() { 
  // },
  computed: {
    filterKode() {
      return this.tblData.kodeacc;
    },
    filterNama() {
      return this.tblData.namaacc;
    },
    isValid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    }
  },
  watch: {
    filterKode: function(kodeacc) {
      const tblData = this.tblData;
      const refresh = this.refresh;
      setTimeout(() => {
        if (kodeacc == tblData.kodeacc) refresh();
      }, 500);
    },
    filterNama: function(namaacc) {
      const tblData = this.tblData;
      const refresh = this.refresh;
      setTimeout(() => {
        if (namaacc == tblData.namaacc) refresh();
      }, 500);
    }
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
    //   this.tblData.namaacc = this.tblData.filter;

      const list = await coa.list(this.tblData);      
      return list;
    },
    add: function() {
      this.model = { kodeacc: '', namaacc:'' };
      this.formTitle='Add - Chart of Account';
      this.showForm = true;
    },
    edit: function(data) {
      const item={};
      for (var key in data) {
          if (data[key])
          item[key] = data[key];
      }      
      this.model = item;
      this.model.kodelama=item.kodeacc;
      this.model.tahunlama=item.tahun;
      this.formTitle='Edit - Chart of Account';
      this.showForm = true;
    },
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      try {
          await coa.remove(this.model);
          this.refresh();
      } catch (error) {
          console.log('error : ', error);
          if (error.sql) {
              toastr.error(error.sql,'ERROR MESSAGE',10000);
          } else if (error.sqlMessage) {
              toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
          } else if (error.message) {
              toastr.error(error.message,'ERROR MESSAGE',10000);
          } else {
              toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
          }        
      }

    },
    handleOk: function(evt) {
      const { model, isValid } = this;
        // console.log('isValid : ', isValid)
      evt.preventDefault()
      if (!isValid) {
        alert('Please fill the form correctly.')
      } else {
        this.save()
      }
    },
    save: async function() {
      const { model, isValid } = this;
      if (isValid==true) {
        try {
          if (this.formTitle == "Add - Chart of Account") {
            await coa.insert(model);
          } else {
            await coa.update(model);
          }
          this.showForm = false;
          this.refresh();
        } catch (error) {
            // console.log('save : ', error)
          toastr.error(JSON.stringify(error), "ERROR MESSAGE");
        }
      }
    },
    print: async function() {
          try {              this.showReport=true;

              this.reportUrl= await coa.print(this.tblData);

          } catch (error) {
              console.log('error : ', error);
              if (error.sql) {
                  toastr.error(error.sql,'ERROR MESSAGE',10000);
              } else if (error.sqlMessage) {
                  toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
              } else if (error.message) {
                  toastr.error(error.message,'ERROR MESSAGE',10000);
              } else {
                  toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
              }        
          }

    },
    exportXls: async function() {
      try {
          const obj = {kodeacc: this.tblData.kodeacc, namaacc: this.tblData.namaacc };
          const response = await coa.exportXls(obj);
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'consolidation_coa.xlsx');
          document.body.appendChild(link);
          link.click();
      } catch (error) {
          this.isLoading=false;            
          console.log('error : ', error);
          if (error.sql) {
              toastr.error(error.sql,'ERROR MESSAGE',10000);
          } else if (error.sqlMessage) {
              toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
          } else if (error.message) {
              toastr.error(error.message,'ERROR MESSAGE',10000);
          } else {
              toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
          }        
      }

    },
    refresh() {
      this.$refs.table.refresh();
    },
    close(){
      router.push("home");
    }    
  }
};
</script>
